/**
 * Guía: Compañías (Soporte).
 *
 * Contenido derivado del capítulo **40** del manual: §0 (para qué existe la
 * pantalla) y §1 (el permiso de escritura del responsable de soporte, que
 * vive en tres sitios independientes).
 *
 * Corta porque su valor es saber en qué se diferencia de las otras dos
 * pantallas sobre la misma entidad — que es lo que más confunde del módulo.
 */

import type { TourFlow } from '../types';

const SOPORTE_PATH = '/support-companies';

export const c40CompaniasSoporte: TourFlow = {
  id: 'admin.support-companies',
  chapter: '40',
  title: 'Compañías (Soporte)',
  summary:
    'La vista de soporte sobre las compañías del país, y qué se puede tocar desde aquí.',
  href: SOPORTE_PATH,
  requiresCountry: true,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Las compañías del país, desde soporte',
      body:
        'Hay tres pantallas sobre la misma entidad y ésta es la de soporte. Sirve para ' +
        'entrar a una compañía cuando llega un caso, y para asignarle o cambiarle el asesor.',
      route: SOPORTE_PATH,
    },
    {
      id: 'not-the-approval-screen',
      title: 'Aprobar y suspender no están aquí',
      body:
        'Esas decisiones viven en la pantalla de Compañías y son del administrador general. ' +
        'Desde aquí se consulta y se gestionan asesores.',
      target: 'admin.supportCompanies.filters',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'unassign-keeps-history',
      title: 'Quitar un asesor no borra lo que generó',
      body:
        'Se marca la fecha de baja en lugar de borrar la asignación, porque de ella cuelgan ' +
        'sus comisiones. Borrarla dejaría pagos sin explicación.',
    },
  ],
};
